/**
 * Created by WebStorm.
 * User: athukorala
 * Date: 7/14/19
 * Time: 12:10 PM
 */
import React, {Component} from 'react';
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {Card, CardBody, CardHeader, Col, Row} from "reactstrap";
import './Update.css'
import TxtLbl from "../../../../../components/Input/Input/TxtLbl";
import Lbl from "../../../../../components/Label/Lbl";
import {Button, Icon, Input, Form, Checkbox} from "semantic-ui-react";
import LabelDropdown from "../../../../../components/Dropdown/LabelDropdown/LabelDropdown";
import Cookies from "js-cookie";
import axiosTags from "../../../../../axios/axios_tag";
import * as common from "../../../../../const/Common/CommonFunc";
import * as EmailValidator from "email-validator";
import * as actionCreator from "../../../../../store/Action";
import {connect} from "react-redux";
import swal from "sweetalert";
import are_you_sure_icon from "../../../../../assets/img/sweet/question.svg";
import apiConfig from "../../../../../axios/axios_api_services";

class App extends Component {
  state = {
    id: '',
    email: '',
    username: '',
    name: '',
    old_password: '',
    new_password:'',
    re_new_password:'',
    validatePassword: false,
    isPassword: false,
    system_list: [],
    status: false
  };

  toggle = () => {
  };
  handleChange = name => event => {
    let value = event.target.value;

    if (name === "password") {
      let reg = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{9,}$)");
      let result = reg.test(value);
      if (result) {
        this.setState({
          validatePassword: true,
          [name]: value
        });
      } else {
        this.setState({
          validatePassword: false,
          [name]: value
        });
      }
    } else {
      this.setState({
        [name]: value
      });
    }
  };
  fillData = () => {
    let data = this.props.data;

    this.setState({
      email: data.email,
      username: data.userName,
      name: data.fullName,
      status: data.status === 1,
      id: data.corporates.length !== 0 ? data.corporates[0].corporateId : 0
    })

  };
  viewPassword = (index) => {
    if(index === 1){
      let i = document.getElementById("password-field");
      if (i.type === "password") {
        i.type = "text"
      } else {
        i.type = "password"
      }
    }else{
      let i = document.getElementById("password-field-1");
      if (i.type === "password") {
        i.type = "text"
      } else {
        i.type = "password"
      }
    }

  };

  updateCorAdmin = () => {
    let passwordReg = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#\\$%\\^&\\*])(?=.{9,}$)");

    let condition = false;
    const {email, name, username, id,old_password,new_password,re_new_password} = this.state;
    if (email.trim() === "" || name.trim() === "" || username.trim() === "" || id === "") {
      common.notifyMessage("Please enter all required fields");
    } else {
      let validateEmail = EmailValidator.validate(email);
      if (validateEmail) {
        if (this.state.isPassword) {
          if(old_password.trim() === "" || new_password.trim() === "" || re_new_password.trim() === "" ){
            common.notifyMessage("Please enter all required fields");
          }else{
            if(new_password.trim() !== re_new_password.trim()){
              common.notifyMessage("Passwords do not match")
            }else{
              !passwordReg.test(new_password.trim()) ? common.notifyMessage("Password must contain at least 9 characters, including UPPER/LOWERCASE/SPECIAL_CHARACTER and NUMBERS") : condition = true;
            }
          }
        } else {
          condition = true;
        }
      } else {
        common.notifyMessage("Please enter valid email address");
      }
    }

    if(condition){
      swal({
            title: "Do you want to update system admin?",
            icon: are_you_sure_icon,
            closeOnClickOutside: false,
            buttons: {
              cancel: 'Cancel',
              dangerMode: {
                text: "Yes",
                value: "action",
                className: "okay-btn"
              }
            },
          })
            .then((value) => {
              switch (value) {

                case "action":
                  this.sendToBackend();
                  break;
                default:
              }
            });
    }
  };
  sendToBackend = () => {
    const {email, name, username, corporateId, old_password,new_password, status} = this.state;

    const obj = {
      "userId": this.props.data.userId,
      "userName": username,
      "password": old_password.trim(),
      "newPassword": new_password.trim(),
      "fullName": name,
      "email": email,
      "status": status ? 1 : 0,
      "userRoles": "SYS_ADMIN",
      "branches": []
    };

    this.props.spinnerHandler(true);

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };

    axiosTags.post(apiConfig.SYSTEM_ADMIN, obj, {headers: headers})
      .then(response => {
        if (response.data.success) {
          common.warningAlert("System admin successfully updated - (" + username + ")", 0);
          this.props.closeModal();
          this.props.refreshData();
        } else {
          common.warningAlert(response.data.message, 1)
        }
      })
      .catch(async error => {
        this.props.closeModal();
        this.props.refreshData();
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackend()
        }
      })
      .finally(fin => {
        this.props.spinnerHandler(false);
      });
  };

  componentDidMount() {
    this.fillData();
  }

  render() {

    let system_list = this.state.system_list;
    let system_options = [];
    if (system_list.length !== 0) {
      system_list.map((cor, index) => {
        const obj = {
          key: index,
          text: cor.corporateName,
          value: cor.corporateId,
          // image: {avatar: true, src: cor.photoPath},
        };
        system_options.push(obj)
      })
    }
    return (
      <div>
        <MDBModal isOpen={true} toggle={this.toggle} size="xl">
          <MDBModalHeader className={"title"} toggle={this.props.closeModal}>Update System Admin Details</MDBModalHeader>
          <MDBModalBody>
            <Row style={{padding: '10px'}}>
              <Col xs="12" lg={"6"} md={"6"} className={"padd_grap"}>
                <Card className={this.state.completeCorporateAdmin ? "border-danger" : null}>
                  <CardHeader>
                    Update System Admin Details
                  </CardHeader>
                  <CardBody>
                    <Form>
                      <Form.Group widths='equal'>
                        <TxtLbl
                          required
                          tagText={"Email"}
                          placeholder={"Email"}
                          value={this.state.email}
                          onChange={this.handleChange('email')}
                        />

                      </Form.Group>

                      <Form.Group widths='equal'>
                        <TxtLbl
                          required
                          tagText={"Full Name"}
                          placeholder={"Full name"}
                          value={this.state.name}
                          onChange={this.handleChange('name')}
                        />
                      </Form.Group>

                      <br/>
                      <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                                checked={this.state.status} onChange={() => this.setState({status: !this.state.status})}
                                toggle
                                label={this.state.status ? 'Active' : 'Inactive'}/>
                    </Form>

                  </CardBody>
                </Card>
              </Col>

              <Col xs="12" lg={"6"} md={"6"} className={"padd_grap"}>
                <Card className={this.state.completeCorporateAdmin ? "border-danger" : null}>
                  <CardHeader>
                    Update Credentials
                  </CardHeader>
                  <CardBody>

                    <Form>
                      <Form.Group widths='equal'>
                        <TxtLbl
                          required
                          tagText={"Username"}
                          placeholder={"Username"}
                          value={this.state.username}
                          onChange={this.handleChange('username')}
                        />

                      </Form.Group>

                      <Col className={"none-padding"} lg={12}>
                        <Checkbox style={{fontWeight: '600', color: 'rgba(72, 72, 72, 0.87)!important'}}
                                  checked={this.state.isPassword}
                                  onChange={() => this.setState({
                                    isPassword: !this.state.isPassword,
                                    password: "",
                                    validatePassword: false,
                                    new_password:'',old_password:'',re_new_password:''
                                  })} toggle
                                  label='Do you want to change admin password'/>

                        {
                          this.state.isPassword ?
                            <div>
                              <div>
                                <Lbl required>Enter old password</Lbl>
                                <Input id={"password-field"}
                                       value={this.state.old_password}
                                       onChange={this.handleChange('old_password')}
                                       type={"password"} style={{width: '100%'}}
                                       icon={<Icon onMouseUp={() => this.viewPassword(1)}
                                                   onMouseDown={() => this.viewPassword(1)} name='eye' circular
                                                   link/>}
                                       placeholder='Old password'/>
                              </div>
                              <div>
                                <Lbl required>Enter new password</Lbl>
                                <Input id={"password-field-1"}
                                       value={this.state.new_password}
                                       onChange={this.handleChange('new_password')}
                                       type={"password"} style={{width: '100%'}}
                                       icon={<Icon onMouseUp={() => this.viewPassword(2)}
                                                   onMouseDown={() => this.viewPassword(2)} name='eye' circular
                                                   link/>}
                                       placeholder='New password'/>
                              </div>
                              <div>
                                <Lbl required>Re-enter new password</Lbl>
                                <Input id={"password-field"}
                                       value={this.state.re_new_password}
                                       onChange={this.handleChange('re_new_password')}
                                       type={"password"} style={{width: '100%'}}
                                       placeholder='New password'/>
                              </div>
                            </div>
                            : null
                        }

                      </Col>
                    </Form>

                  </CardBody>
                </Card>
              </Col>

              <Col lg={"12"} className={"text-align-path"} style={{marginBottom: '5px'}}>
                <Button className="px-5" onClick={this.updateCorAdmin}>Update System Admin</Button>
              </Col>
            </Row>
          </MDBModalBody>
        </MDBModal>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  view_all_corporates: state.viewAllReducer.view_all_corporates,
  corporate_headers: state.viewAllReducer.corporate_headers
});

const mapDispatchToProps = (dispatch) => {
  return {
    // spinner handler
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
    //user data handler:
    userHandler: (data) => dispatch(actionCreator.userHandler(data))
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(App);
